.root {
  flex: 1;
  overflow-y: auto;
  padding: 24px clamp(16px, 4vw, 48px);
}

.stream {
  max-width: var(--content-max-width);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
